module.exports = __webpack_public_path__ + "ico-sp.26ccbb5841e519cceccb.svg";


//////////////////
// WEBPACK FOOTER
// /Users/nikolay/Documents/GitHub/menu-web/src/assets/img/ico-sp.svg
// module id = ../../../../../src/assets/img/ico-sp.svg
// module chunks = styles